import { StatusBadgeType } from '../status-badge/status-badge-code';

/** Booking payment state, independent from the booking/service status (backend EBookingPaymentStatus). */
export enum EBookingPaymentStatus {
  NotRequired = 1,
  Pending = 2,
  Paid = 3,
  PartiallyPaid = 4,
  Failed = 5,
  PartiallyRefunded = 6,
  Refunded = 7,
}

export const PAYMENT_STATUS_BADGE_TYPE: Record<
  EBookingPaymentStatus,
  StatusBadgeType
> = {
  [EBookingPaymentStatus.NotRequired]: 'default',
  [EBookingPaymentStatus.Pending]: 'warning',
  [EBookingPaymentStatus.Paid]: 'success',
  [EBookingPaymentStatus.PartiallyPaid]: 'amber',
  [EBookingPaymentStatus.Failed]: 'error',
  [EBookingPaymentStatus.PartiallyRefunded]: 'sky',
  [EBookingPaymentStatus.Refunded]: 'gray',
};
